export const ACTION_TYPES = {
    REQUEST_CITIES: 'REQUEST_CITIES',
    RECEIVE_CITIES: 'RECEIVE_CITIES',
    RECEIVE_CITIES_ERROR: 'RECEIVE_CITIES_ERROR',
    REQUEST_DISTRICT: 'REQUEST_DISTRICT',
    RECEIVE_DISTRICT: 'RECEIVE_DISTRICT',
    REQUEST_SUBDISTRICT: 'REQUEST_SUBDISTRICT',
    RECEIVE_SUBDISTRICT: 'RECEIVE_SUBDISTRICT',
    REQUEST_RESIDENTIAL_CITIES: 'REQUEST_RESIDENTIAL_CITIES',
    RECEIVE_RESIDENTIAL_CITIES: 'RECEIVE_RESIDENTIAL_CITIES',
    REQUEST_RESIDENTIAL_DISTRICT: 'REQUEST_RESIDENTIAL_DISTRICT',
    RECEIVE_RESIDENTIAL_DISTRICT: 'RECEIVE_RESIDENTIAL_DISTRICT',
    REQUEST_RESIDENTIAL_SUBDISTRICT: 'REQUEST_RESIDENTIAL_SUBDISTRICT',
    RECEIVE_RESIDENTIAL_SUBDISTRICT: 'RECEIVE_RESIDENTIAL_SUBDISTRICT',
    REQUEST_CORRESPONDENCE_CITIES: 'REQUEST_CORRESPONDENCE_CITIES',
    RECEIVE_CORRESPONDENCE_CITIES: 'RECEIVE_CORRESPONDENCE_CITIES',
    REQUEST_NPWP_CITIES: 'REQUEST_NPWP_CITIES',
    RECEIVE_NPWP_CITIES: 'RECEIVE_NPWP_CITIES',
    REQUEST_NPWP_DISTRICT: 'REQUEST_NPWP_DISTRICT',
    RECEIVE_NPWP_DISTRICT: 'RECEIVE_NPWP_DISTRICT',
    REQUEST_NPWP_SUBDISTRICT: 'REQUEST_NPWP_SUBDISTRICT',
    RECEIVE_NPWP_SUBDISTRICT: 'RECEIVE_NPWP_SUBDISTRICT',
};

const initialState = { entities: [], isLoading: false };

export const cityActions = {
    requestCities: (provinceId) => async (dispatch) => {

        //dispatch({ type: ACTION_TYPES.REQUEST_CITIES });

        //const url = `api/city?id=${provinceId}`;

        //    const response = await fetch(url);

        //    const entities = await response.json();
        //    dispatch({ type: ACTION_TYPES.RECEIVE_CITIES, entities });
       
        dispatch({ type: ACTION_TYPES.REQUEST_CITIES });
        const url = `api/city?id=${provinceId}`;

        try {

            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const entities = await response.json();
            dispatch({ type: ACTION_TYPES.RECEIVE_CITIES, entities });
           
        } catch (error) {
            console.error('Error fetching cities:', error);
            dispatch({ type: ACTION_TYPES.RECEIVE_CITIES_ERROR, error: error.message });
        }
    },

    requestDistrict: (cityId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_DISTRICT });

        const url = `api/postalcode?cityId=${cityId}&tipe=district`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_DISTRICT, entities });
    },

    requestSubDistrict: (districtName) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_SUBDISTRICT });

        const url = `api/postalcode?districtName=${districtName}&tipe=subdistrict`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_SUBDISTRICT, entities });
    },

    requestResidentialCities: (provinceId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_RESIDENTIAL_CITIES });

        if (provinceId !== "") {
            const url = `api/city?id=${provinceId}`;
            const response = await fetch(url);
            const entities = await response.json();

            dispatch({ type: ACTION_TYPES.RECEIVE_RESIDENTIAL_CITIES, entities });
        } else {
            dispatch({ type: ACTION_TYPES.RECEIVE_RESIDENTIAL_CITIES, entities: null });
        }
    },

    requestResidentialDistricts: (cityId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_RESIDENTIAL_DISTRICT });

        const url = `api/postalcode?cityId=${cityId}&tipe=district`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_RESIDENTIAL_DISTRICT, entities });
    },

    requestResidentialSubDistricts: (districtName) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_RESIDENTIAL_SUBDISTRICT });

        const url = `api/postalcode?districtName=${districtName}&tipe=subdistrict`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_RESIDENTIAL_SUBDISTRICT, entities });
    },

    requestNPWPCities: (provinceId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_NPWP_CITIES });
        if (provinceId !== "") {
            const url = `api/city?id=${provinceId}`;
            const response = await fetch(url);
            const entities = await response.json();
            dispatch({ type: ACTION_TYPES.RECEIVE_NPWP_CITIES, entities });
        } else {
            dispatch({ type: ACTION_TYPES.RECEIVE_NPWP_CITIES, entities: null });
        }
    },

    requestNPWPDistricts: (cityId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_NPWP_DISTRICT });
        const url = `api/postalcode?cityId=${cityId}&tipe=district`;
        const response = await fetch(url);
        const entities = await response.json();
        dispatch({ type: ACTION_TYPES.RECEIVE_NPWP_DISTRICT, entities });
    },

    requestNPWPSubDistricts: (districtName) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_NPWP_SUBDISTRICT });
        const url = `api/postalcode?districtName=${districtName}&tipe=subdistrict`;
        const response = await fetch(url);
        const entities = await response.json();
        dispatch({ type: ACTION_TYPES.RECEIVE_NPWP_SUBDISTRICT, entities });
    },

    requestCorrespondenceCities: (provinceId) => async (dispatch) => {
        dispatch({ type: ACTION_TYPES.REQUEST_CORRESPONDENCE_CITIES });

        const url = `api/city?id=${provinceId}`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_CORRESPONDENCE_CITIES, entities });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case (ACTION_TYPES.REQUEST_CITIES):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_CITIES):
            return {
                ...state,
                isLoading: false,
                entities: action.entities
            }
        case (ACTION_TYPES.RECEIVE_CITIES_ERROR):
            return {
                ...state,
                isLoading: false,
                message: action.error
            };
        case (ACTION_TYPES.REQUEST_RESIDENTIAL_CITIES):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_RESIDENTIAL_CITIES):
            return {
                ...state,
                isLoading: false,
                residentialCitiesEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_CORRESPONDENCE_CITIES):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_CORRESPONDENCE_CITIES):
            return {
                ...state,
                isLoading: false,
                correspondenceCitiesEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_DISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_DISTRICT):
            return {
                ...state,
                isLoading: false,
                districtEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_SUBDISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_SUBDISTRICT):
            return {
                ...state,
                isLoading: false,
                subDistrictEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_RESIDENTIAL_DISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_RESIDENTIAL_DISTRICT):
            return {
                ...state,
                isLoading: false,
                residentialDistrictEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_RESIDENTIAL_SUBDISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_RESIDENTIAL_SUBDISTRICT):
            return {
                ...state,
                isLoading: false,
                residentialSubDistrictEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_NPWP_CITIES):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_NPWP_CITIES):
            return {
                ...state,
                isLoading: false,
                npwpCitiesEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_NPWP_DISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_NPWP_DISTRICT):
            return {
                ...state,
                isLoading: false,
                npwpDistrictEntities: action.entities
            };
        case (ACTION_TYPES.REQUEST_NPWP_SUBDISTRICT):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_NPWP_SUBDISTRICT):
            return {
                ...state,
                isLoading: false,
                npwpSubDistrictEntities: action.entities
            };
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/store/City.Reducer.js